export enum CallRecordingSettings {
    Off = 'off',
    RecordCalls = 'recordCalls',
    RecordAndAutoTranscribe = 'recordAndAutoTranscribe',
    AutoTranscribeOnly = 'autoTranscribeOnly',
}

export enum SettingsType {
    Business = 'business',
    Personal = 'personal',
    Monitoring = 'monitoring',
}
